import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import apiClient from "api/client";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";

class DropDownTvCategoryMulti extends Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: true,
            tvCategory: []
        };

    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    componentDidMount() {

        //console.log("DropDownTvCategory->componentDidMount: "+this.props.applicationid);
        let url = process.env.REACT_APP_API_URL+"/Channels/categories";

        if(this.props.applicationid){
            url = process.env.REACT_APP_API_URL+"/ApplicationsManagement/"+this.props.applicationid+"/channel-categories";
        }


        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if(user){
            token = user.token
        }
        else{
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };

        apiClient.get(url,axiosConfig)
            .then(res => {
                const tvCategory = res.data;
                const loading = false;
                this.setState({tvCategory, loading});
            })
            .catch(error => {
                this.setState({loading: false});
                console.log(error);
                this.props.dispatch(userActions.logoutUnauthorized());
            });
    }

    render() {
        return (
            <Select
                placeholder="Category Select"
                name="categorySelect"
                autoFocus={false}
                multi={true}
                isSearchable={true}
                disabled={this.props.disabled}
                value={this.props.categorySelected}
                options={this.state.tvCategory}
                onChange={value => this.handleSelect(value)}

            />
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownTvCategoryMulti = connect(mapStateToProps)(DropDownTvCategoryMulti);
const connectedDropDownTvCategoryMultiTrans = withNamespaces('common')(connectedDropDownTvCategoryMulti);
export {connectedDropDownTvCategoryMultiTrans as DropDownTvCategoryMulti};
